import script from "./PCPartsDetailsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCard.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCard.vue?vue&type=style&index=0&id=076e4d1c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076e4d1c"]])

export default __exports__